export const week_options = [4, 12, 24, 28, 52];

export const platform_access_package_uuid = '9ed2ff97-de27-408f-8366-0f4a54b757ef';

// GET /cms/api/active_packages appends Platform Access to the catalog only so the downgrade flow
// has a target that resolves to a tier (agentic-skills/guardrails/packages/packages.md), which is
// why Create Membership dropped it: it is a downgrade destination, not something Care sells.
// PROD-9387 opens it to super users alone; a caller that passes no flag still gets the filtered
// list, so Care cannot inherit it by accident.
export const filter_create_membership_packages = (active_packages, is_super_user) =>
  is_super_user
    ? active_packages
    : active_packages.filter(
        (active_package) => active_package.uuid !== platform_access_package_uuid
      );

// apis renewal_service.ts:107 rejects Platform Access on any term but 4 weeks ("This package ($19)
// is not available for prepayment plans"), and this form defaults to 28. Offering the full list
// would quote a price on the preview endpoint, which does not apply that rule, and then 400 on
// Confirm.
export const get_week_options = (package_uuid) =>
  package_uuid === platform_access_package_uuid ? [4] : week_options;

// Resolved on read rather than clamped into state, so switching to Platform Access and back
// restores the term the user had picked instead of leaving 4 behind.
export const resolve_number_of_week = (package_uuid, number_of_week) => {
  const options = get_week_options(package_uuid);
  return options.includes(Number(number_of_week)) ? Number(number_of_week) : options[0];
};

export const get_selected_package = (active_packages, package_uuid) =>
  active_packages.find((active_package) => active_package.uuid === package_uuid) || {};

export const build_active_packages_url = (active_packages_url, student_uuid) =>
  `${active_packages_url}?student_uuid=${encodeURIComponent(student_uuid)}`;

export const build_create_membership_payload = ({
  package_uuid,
  student_uuid,
  subscription_start_date,
  number_of_week,
  change_to_four_weeks_on_renewal,
  country
}) => ({
  package_uuid,
  student_uuid,
  subscription_start_date,
  discount_3m_plan_1m_free: 0,
  number_of_week: Number(number_of_week),
  source: 'WEB',
  platform: '',
  country: country || 'US',
  plan_purchase_on_cancellation: 0,
  // is_free_month_offer omitted: the server resolves LTO eligibility from the student.
  change_to_four_weeks_on_renewal: change_to_four_weeks_on_renewal ? 1 : 0
});

// Must carry the same values as build_create_membership_payload: `source` gates membership credits
// server-side, so a mismatch changes the quoted price.
export const build_charge_preview_url = (charge_preview_url, payload) => {
  const query = new URLSearchParams({
    student_uuid: payload.student_uuid,
    package_uuid: payload.package_uuid,
    number_of_week: String(payload.number_of_week),
    subscription_start_date: payload.subscription_start_date || '',
    discount_3m_plan_1m_free: String(payload.discount_3m_plan_1m_free),
    plan_purchase_on_cancellation: String(payload.plan_purchase_on_cancellation),
    source: payload.source
  });
  return `${charge_preview_url}?${query.toString()}`;
};

// purchase_price is already rounded to the cents that will be charged; format only.
export const format_preview_amount = (preview) => {
  if (!preview || preview.purchase_price === undefined || preview.purchase_price === null) {
    return 'Not available';
  }
  const currency_symbol = preview.currency_symbol || '$';
  const currency = preview.currency || 'USD';
  return `${currency_symbol}${Number(preview.purchase_price).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} ${currency}`;
};
